import type { BorderRadius, BorderSize } from '..';

export const borderSize: BorderSize = {
  0: 0,
  1: 1,
  2: 2,
  4: 4,
  6: 6,
  8: 8,
  12: 12,
};

export const borderRadius: BorderRadius = {
  0: 0,
  2: 2,
  4: 4,
  8: 8,
  12: 12,
  16: 16,
  20: 20,
  24: 24,
  999: 999,
};
